import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import './ProductividadModal.css'; // Usaremos un CSS para el modal

// Genera todos los intervalos de 15 minutos para un día completo
const generateFullDayLabels = () => {
  const labels = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      const hour = String(h).padStart(2, '0');
      const minute = String(m).padStart(2, '0');
      labels.push(`${hour}:${minute}`);
    }
  }
  return labels;
};

const ProductividadModal = ({ user, onClose, userColor, date, movimiento }) => {

  const [dailyCharts, setDailyCharts] = useState({});

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);



  // Efecto para cerrar el modal con la tecla ESC

  useEffect(() => {

    const handleKeyDown = (event) => {

      if (event.key === 'Escape') {

        onClose();

      }

    };



    document.addEventListener('keydown', handleKeyDown);



    // Limpiar el event listener cuando el componente se desmonta

    return () => {

      document.removeEventListener('keydown', handleKeyDown);

    };

  }, [onClose]);



  useEffect(() => {

    if (!user) return;



    const fetchData = async () => {

      try {

        setLoading(true);

        

        let apiUrl = `/api/data/productividad/intervalos?usuario=${user}`;

        if (date) {
          apiUrl += `&fecha=${date}`;
        }

        if (movimiento) {
          apiUrl += `&movimiento=${movimiento}`;
        }

        const response = await fetch(apiUrl);

        if (!response.ok) throw new Error(`Error al obtener los datos: ${response.statusText}`);

        const data = await response.json();



        const groupedByDay = data.reduce((acc, item) => {

          // Corregir el problema de timezone: agrupar por fecha local, no UTC.

          const d = new Date(item.intervalo);

          const year = d.getFullYear();

          const month = String(d.getMonth() + 1).padStart(2, '0');

          const day = String(d.getDate()).padStart(2, '0');

          const localDate = `${year}-${month}-${day}`;



          if (!acc[localDate]) acc[localDate] = [];

          acc[localDate].push(item);

          return acc;

        }, {});



        const charts = {};

        const fullDayLabels = generateFullDayLabels();



        for (const day in groupedByDay) {

          const dayData = groupedByDay[day];

          const totalRecords = dayData.reduce((sum, item) => sum + parseInt(item.cantidad, 10), 0);



          const dataMap = new Map(

            dayData.map(item => {

              const timeLabel = new Date(item.intervalo).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });

              return [timeLabel, item.cantidad];

            })

          );

          

          const chartValues = fullDayLabels.map(label => dataMap.get(label) || 0);



          charts[day] = {

            totalRecords,

            chartData: {

              labels: fullDayLabels,

              datasets: [{

                label: `Registros para ${user}`,

                data: chartValues,

                backgroundColor: userColor || 'rgba(75, 192, 192, 0.6)',

                borderColor: userColor ? userColor.replace('0.6', '1') : 'rgba(75, 192, 192, 1)',

                borderWidth: 1,

                barPercentage: 1.0,

                categoryPercentage: 1.0,

              }],

            }

          };

        }

        

        setDailyCharts(charts);

        setError(null);

      } catch (err) {

        setError(err.message);

        setDailyCharts({});

      } finally {

        setLoading(false);

      }

    };



    fetchData();

  }, [user, userColor, date, movimiento]);



  return (

    <div className="modal-backdrop" onClick={onClose}>

      <div className="modal-dialog modal-xl modal-dialog-scrollable" onClick={e => e.stopPropagation()}>

        <div className="modal-content">

          <div className="modal-header">

            <h5 className="modal-title">Historial de Productividad ({movimiento}): {user}</h5>

            <button type="button" className="btn-close" onClick={onClose}></button>

          </div>

          <div className="modal-body">

            {loading && <p>Cargando gráficos...</p>}

            {error && <p style={{ color: 'red' }}>Error: {error}</p>}

            

            {!loading && !error && Object.keys(dailyCharts).length === 0 && <p>No hay datos de productividad para este usuario.</p>}



            {Object.keys(dailyCharts).sort((a, b) => new Date(b) - new Date(a)).map(day => {

        // FIX: Crear la fecha del título en la zona horaria local para evitar el bug de medianoche UTC.

        const [year, month, dayOfMonth] = day.split('-').map(Number);

        const titleDate = new Date(year, month - 1, dayOfMonth);

        const dayInfo = dailyCharts[day];



        return (

        <div key={day} style={{ marginBottom: '40px', height: '300px' }} className="chart-container">

          <h6>

            {titleDate.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}

            <span style={{ fontWeight: 'normal', marginLeft: '10px', color: '#555' }}>

              ({dayInfo.totalRecords} Registros)

            </span>

          </h6>

          <Bar

            data={dayInfo.chartData}

            options={{

              responsive: true,

              maintainAspectRatio: false,

              scales: { y: { beginAtZero: true, title: { display: true, text: 'N° Registros' } }, x: { title: { display: true, text: 'Hora' } } },

              plugins: { 

                legend: { display: false },

                datalabels: {

                  display: (context) => context.dataset.data[context.dataIndex] > 0, // Mostrar solo si el valor es > 0

                  color: 'black',

                  anchor: 'end',

                  align: 'start', // Alinea la etiqueta DENTRO de la barra

                  offset: -2, // Pequeño ajuste para que no pegue al borde

                  font: {

                    weight: 'bold'

                  }

                }

              }

            }}

          />

        </div>

      )})}

          </div>

          <div className="modal-footer">

            <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>

          </div>

        </div>

      </div>

    </div>

  );

};

export default ProductividadModal;